// extracted by mini-css-extract-plugin
export default {"root":"DishesTableBarCode_root__ns3pP","button":"DishesTableBarCode_button__c6E22","placeHolderShimmer":"DishesTableBarCode_placeHolderShimmer__SLrQZ"};